export default "__VITE_ASSET__341f467d__"